import * as themeHelper from 'lib/helpers/themeHelper';
import { Organization } from 'lib/types/company';
import { ReactNode } from 'react';
import { WhiteLabelContext } from './context';
import {
  getCoursePreviewImageSrc,
  getFaviconHref,
  getHelpCenterUrl,
  getHomePageName,
  getHowItWorksUrl,
  getOrganizationFromHost,
  getOrganizationName,
  getQuestionsEmail,
  getSupportEmail,
  getSurvicateKey,
  getTermsOfServiceUrl,
} from './helpers';

interface IWhiteLabelContextProviderProps {
  children: ReactNode;
  host?: string;
  organization?: Organization;
}

export const WhiteLabelContextProvider = ({
  children,
  host,
  organization: passedOrganization,
}: IWhiteLabelContextProviderProps) => {
  const organization = passedOrganization || getOrganizationFromHost(host);
  const organizationTheme =
    themeHelper.getThemePropertiesForOrganization(organization);
  return (
    <WhiteLabelContext.Provider
      value={{
        coursePreviewImageSrc: getCoursePreviewImageSrc(organization),
        faviconHref: getFaviconHref(organization),
        helpCenterUrl: getHelpCenterUrl(organization),
        homePageName: getHomePageName(organization),
        howItWorksUrl: getHowItWorksUrl(organization),
        organization,
        organizationName: getOrganizationName(organization),
        organizationTheme,
        primaryColor: organizationTheme.primaryColorHex,
        questionsEmail: getQuestionsEmail(organization),
        supportEmail: getSupportEmail(organization),
        survicateKey: getSurvicateKey(organization),
        termsOfServiceUrl: getTermsOfServiceUrl(organization),
      }}
    >
      {children}
    </WhiteLabelContext.Provider>
  );
};
